import {BlockCaseStudiesSlider} from "./BlockCaseStudiesSlider";
import {BlockCaseStudiesLoop} from "./BlockCaseStudiesLoop";

export const PluginCaseStudies = {
	init(): void {
		BlockCaseStudiesSlider();

		const caseStudiesLoops = document.querySelectorAll( '.wv-case-studies-loop' ) as NodeListOf<HTMLElement>;
		caseStudiesLoops.forEach( (container: HTMLElement) => {
			BlockCaseStudiesLoop( container );
		} );
	}
}
